var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestTimeOffI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65076 12.5047C4.15076 12.5047 1.66325 12.65 1.37804 12.5047C1.12715 12.3769 0.923178 12.1729 0.795351 11.922C0.650024 11.6368 0.650024 11.2634 0.650024 10.5167V4.11666C0.650024 3.36993 0.650024 2.99655 0.795351 2.71134C0.923178 2.46045 1.12715 2.25648 1.37804 2.12865C1.66325 1.98333 2.03662 1.98333 2.78336 1.98333H10.5167C11.2634 1.98333 11.6368 1.98333 11.922 2.12865C12.1729 2.25648 12.3769 2.46045 12.5047 2.71134C12.65 2.99655 12.65 3.36993 12.65 4.11666V5.31666M3.31669 0.649994V2.71134M9.98336 0.649994V2.71134M0.650024 4.64999H12.65",
    stroke: "#3E82FF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65076 10.6495C6.65076 8.44037 8.44162 6.64951 10.6508 6.64951C12.8599 6.64951 14.6508 8.44037 14.6508 10.6495C14.6508 12.8586 12.8599 14.6495 10.6508 14.6495C8.44162 14.6495 6.65076 12.8586 6.65076 10.6495ZM12.1836 11.6714C12.061 11.8552 11.8127 11.9049 11.6289 11.7823L10.5888 11.0889C10.3776 10.9481 10.2508 10.7111 10.2508 10.4573V10.4495V8.64951C10.2508 8.42859 10.4298 8.24951 10.6508 8.24951C10.8717 8.24951 11.0508 8.42859 11.0508 8.64951V10.4354L12.0726 11.1167C12.2564 11.2392 12.3061 11.4876 12.1836 11.6714Z",
    fill: "#3E82FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestTimeOffI);
export default __webpack_public_path__ + "static/media/request-time-off-i.a807e1fe92080ff7f207ec0d68791b56.svg";
export { ForwardRef as ReactComponent };